import {
  deleteNFRTemplate,
  getAllNFRTemplates,
  getAllNFRTemplatesForSubmission,
  importNFRTemplate,
} from '~/api/nfrTemplates';

export interface NFRTemplate {
  name: string;
  id: number;
}

class NFRTemplateServiceClass {
  getAllNFRTemplates = async (): Promise<NFRTemplate[]> => {
    const NFRTemplates = await getAllNFRTemplates();
    // NFRTemplate is the same as ApiNFRTemplate, but api types
    // should not be exposed to components
    return NFRTemplates.reverse();
  };
  getAllNFRTemplatesForSubmission = async (timeDimensionId: number): Promise<NFRTemplate[]> => {
    const NFRTemplates = await getAllNFRTemplatesForSubmission(timeDimensionId);
    // NFRTemplate is the same as ApiNFRTemplate, but api types
    // should not be exposed to components
    return NFRTemplates.reverse();
  };

  importNFRTemplate = async (timeDimensionId: number, file: File) => {
    return await importNFRTemplate(timeDimensionId, file);
  };

  DeleteNFRTemplate = async (NFRid: number) => {
    await deleteNFRTemplate(NFRid);
  };
}

export const NFRTemplateService = new NFRTemplateServiceClass();
